module.exports = __webpack_public_path__ + "static/media/Results-10.56e888e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proof/Results-10.jpg
// module id = 363
// module chunks = 0